<template>
  <div class="game-info" @click.self="$emit('close')">
    <div class="content">
      <span class="close-button material-icons-round" @click="$emit('close')"> close </span>
      <h1>About GeoGrid</h1>
      <p style="text-align: center">
        GeoGrid is a daily trivia game made to put your geography knowledge to the test!
      </p>
      <h2>How to Play</h2>
      <p>
        Guess a country for each box in the board that matches the criteria specified by the box's
        row and column categories. Each box on any given board has anywhere from 5 to 30 unique
        answers. A new game is available every day at 0:00 am, local time of your device!<br />
      </p>
      <h3>Rules</h3>
      <p>
        Players have 10 guesses to fill out the grid, but can enable infinite mode for unlimited. A
        country can only be used once per game board.<br />
      </p>
      <h3>Objective</h3>
      <p>
        Complete the board by filling all 9 boxes with a country that matches the criteria for the
        intersection of categories. Finish with the lowest score possible.
      </p>
      <h3>Scoring</h3>
      <p>
        The score is calculated by the sum of the rarities of each box on the board. Empty cells are
        scored as 100. The rarer the guess, the lower the score. The lower the score, the better.
        More questions? See the <router-link to="/faq" @click="$emit('close')">FAQ</router-link>.
      </p>
      <h3>Privacy</h3>
      <p>You can change your privacy settings by clicking the following button:<br /></p>
      <button class="consent-button" onclick="adconsent('showGUI')">Manage Consent</button>
      <br /><br />
      <button @click="$emit('close')" class="btn-primary">Play Now!</button>
    </div>
  </div>
</template>

<script>
  import { inject } from 'vue';
  export default {
    name: 'GameInfo',
    setup() {
      return {
        userDetails: inject('userDetails'),
      };
    },
  };
</script>

<style scoped>
  .game-info {
    position: fixed;
    top: 0;
    left: 0;
    width: 100%;
    height: 100%;
    background-color: rgba(0, 0, 0, 0.5);
    display: flex;
    justify-content: center;
    align-items: center;
    z-index: 9999;
  }

  .content {
    position: relative; /* Added position relative */
    background-color: rgb(53, 53, 72);
    padding: 32px;
    border-radius: 16px;
    box-shadow: 0px 0px 20px rgba(0, 0, 0, 0.3);
    text-align: center;
    width: 100%;
    max-width: 450px;
    max-height: 80%;
    overflow-y: auto;
    color: #dfdcdc;
    font-weight: bold;
  }

  .content::-webkit-scrollbar {
    width: 10px;
  }

  .content::-webkit-scrollbar-thumb {
    background-color: rgb(141, 139, 139);
    border-radius: 999px;
    border: 2px solid transparent;
    background-clip: content-box;
  }

  .content::-webkit-scrollbar-track {
    background-color: transparent;
    border-radius: 999px;
  }

  .content p {
    text-align: left;
    justify-self: center;
  }

  h1 {
    color: rgb(253, 253, 253);
  }

  h2,
  h3 {
    color: rgba(147, 147, 236, 1);
  }

  h1,
  p {
    word-wrap: break-word;
  }

  p {
    font-size: 14px;
    line-height: 23px; /*as per gold ration*/
  }

  a {
    color: rgba(147, 147, 236, 1);
    text-decoration: none;
  }

  a:hover {
    color: rgba(184, 184, 249, 1);
    text-decoration: underline;
  }

  button {
    padding: 10px 20px;
    font-size: 16px;
    background-color: rgb(141, 139, 139);
    color: #fff;
    border: none;
    border-radius: 5px;
    cursor: pointer;
  }

  .btn-primary {
    height: 44px;
    width: 85%;
    cursor: pointer;
    background-color: rgba(147, 147, 236, 1);
    color: rgba(26, 26, 26, 1);
    border: 1px rgba(147, 147, 236, 1);
    padding: 6px 12px;
    border-radius: 12px;
    transition: background-color 0.3s;
    font-size: 14px;
    font-family: 'Oxygen', Helvetica, Arial, sans-serif;
    font-weight: 700;
    box-sizing: border-box;
  }

  .btn-primary:hover {
    background-color: rgba(184, 184, 249, 1);
  }

  .close-button {
    position: absolute;
    top: 32px;
    right: 32px;
    cursor: pointer;
    font-size: 26px;
    color: rgb(253, 253, 253);
  }

  .close-button::before {
    content: '';
    top: 50%;
    left: 50%;
    transform: translate(-50%, -50%);
    border-radius: 50%;
    background-color: transparent;
    z-index: -1;
  }

  .close-button:hover::before {
    background-color: #f2f2f2;
  }
  .bottom-txt {
    margin-top: -25px;
    font-size: 12px;
    color: rgb(134, 136, 164);
  }

  .consent-button {
    margin-top: 10px;
    height: 44px;
    width: 85%;
    cursor: pointer;
    background-color: transparent;
    color: rgba(147, 147, 236, 1);
    border: 2px rgba(147, 147, 236, 1) solid;
    padding: 6px 12px;
    border-radius: 12px;
    transition: background-color 0.3s;
    font-size: 14px;
    font-family: 'Oxygen', Helvetica, Arial, sans-serif;
    font-weight: 700;
    box-sizing: border-box;
  }

  .consent-button:hover {
    background-color: rgba(0, 0, 0, 0.2);
  }

  @media screen and (max-width: 768px) {
    .content {
      width: 70%;
    }
  }
</style>
